<template>
	<div>

		<div class="ptjsMiddleBox" style="margin-top: 150px;margin-bottom: 35px;">
			<div style="width: 1140px;min-width: 1140px;margin: auto;margin-top: 50px;">
				<div style="color: #150e52;font-size: 30px;font-weight: 600;text-align: center;">
					{{ this.article.rows[0].articleTitle }}
				</div>
				<div class="ptjs" style="font-size: 16px;margin-top: 25px;line-height: 30px;color: #150e52;font-family: PingFangSC-Regular, sans-serif;"
					v-html="this.article.rows[0].articleContent"
				>

				</div>
			</div>

		</div>

	</div>
</template>

<script>
	import mainTop from '../components/mainTop.vue'
	import mainBottom from '../components/mainBottom.vue'
	import axios from 'axios';
	export default {
	  components: {
		  mainTop,
		  mainBottom,

	   },
	   data(){
		   return{
				article:''
			   };
			},
		created(){
			this.getArticle();
		},
		methods:{
			getArticle(){
				axios.get('/web/article/strategy/127?pageNum1&pageSize=1').then((res)=>{
                    this.article=res.data
					// console.log(this.articleContent);
                })
			}
		},
		}
</script>


<style>
	.ptjsMiddleBox{
		width: 100%;
		min-width: 1700px;
		background-color: #f7f7f7;
	}
	.ptjs p{
		text-indent:2rem;
	}
</style>
